import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { IvftSupplementationRedLabelAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface IvftSupplementationRedLabelActionFormGroup {
	rate: FormControl<UnitQuantity | null>;
	totalRate: FormControl<UnitQuantity | null>;
}

@Component({
    selector: 'app-ivtf-supplementation-red-label-action-controls',
    templateUrl: './ivft-supplementation-red-label-action-controls.component.html',
    styleUrls: ['../../../common.scss', './ivft-supplementation-red-label-action-controls.component.scss'],
    imports: [ReactiveFormsModule, UnitQuantityControl, CommonActionControlsComponent, ActionFormComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IvftSupplementationRedLabelActionControlsComponent implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: IvftSupplementationRedLabelAction;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as IvftSupplementationRedLabelAction;
	}

	@Input() form!: FormGroup<IvftSupplementationRedLabelActionFormGroup>;
	@Input() item!: Row;

	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.form.addControl('rate', this.formBuilder.control(this.action?.rate ?? null));
		this.form.addControl('totalRate', this.formBuilder.control(this.action?.totalRate ?? null));
	}
}